import React, { useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ImageLoadedState } from '../../globalInterfaces/learnEngineInterfaces';
import { Loading } from '../../../private/LearnEngineComponents/ImageStates/Loading/Loading';
import { Failed } from '../../../private/LearnEngineComponents/ImageStates/Failed/Failed';

import s from './SlImage.scss';
import { UIComponentType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

interface ISlImageProps {
	path: string;
	onClick: (a: UIComponentType) => void;
	ratio?: number;
}

export function SlImage({ path, ratio = 1, onClick }: ISlImageProps) {
	useStyles(s);
	const [loadedState, setImageLoadedState] = useState<ImageLoadedState>(
		ImageLoadedState.Loading,
	);

	const handleImageOnLoad = () => {
		setImageLoadedState(ImageLoadedState.Success);
	};

	const handleImageOnError = () => {
		setImageLoadedState(ImageLoadedState.Failed);
	};

	const onClickHandler = () => {
		if (onClick) {
			onClick(UIComponentType.Image);
		}
	};

	return (
		<div
			className="sl-image-component"
			sl-test-data="cmpSlImage"
			onClick={onClickHandler}
		>
			{loadedState === ImageLoadedState.Loading && (
				<Loading ratio={ratio} />
			)}
			{loadedState === ImageLoadedState.Failed && (
				<Failed ratio={ratio} />
			)}
			<img
				src={path}
				alt="img-component"
				onLoad={handleImageOnLoad}
				onError={handleImageOnError}
				style={
					loadedState !== ImageLoadedState.Success
						? { visibility: 'hidden' }
						: null
				}
			/>
		</div>
	);
}
